import { TFunction } from 'react-i18next';

import { Currency, formatCurrency } from '@chargify/formatters';
import { SummaryTableRows } from '@chargify/custom-ui-components';
import { ChangePlanPreview } from '../../../machines/changePlan';

type Params = {
  changePlanPreview: ChangePlanPreview;
  t: TFunction<'subscriptions-manager'[]>;
  language: string;
  currency: Currency;
};

export const mapChargeSummaryToTable = ({
  changePlanPreview,
  t,
  language,
  currency,
}: Params) => {
  const formatAmount = (amount: number) =>
    formatCurrency(currency, amount, language);
  const positiveCreditBalance = changePlanPreview.totalInCents > 0;
  const chargesSummary = [
    [
      {
        value: t('plan_change.subtotal'),
        fontWeight: 3,
        fontSize: 1,
      },
      {
        value: formatAmount(changePlanPreview.subtotalInCents),
        fontWeight: 3,
        fontSize: 1,
        textAlign: 'right',
      },
    ],
    [
      {
        value: t('plan_change.taxes'),
        fontWeight: 3,
        fontSize: 1,
      },
      {
        value: formatAmount(changePlanPreview.totalTaxInCents),
        fontWeight: 3,
        fontSize: 1,
        textAlign: 'right',
      },
    ],
  ];
  if (changePlanPreview.productChangeStrategy === 'prorated') {
    chargesSummary.push([
      {
        value: positiveCreditBalance
          ? t('plan_change.credit_balance_to_be_applied')
          : t('plan_change.credit_balance_change'),
        fontWeight: 3,
        fontSize: 1,
      },
      {
        value: `${positiveCreditBalance ? '' : '+'}${formatAmount(
          Math.abs(changePlanPreview.totalInCents)
        )}`,
        fontWeight: 3,
        fontSize: 1,
        textAlign: 'right',
      },
    ]);
  }
  return chargesSummary as SummaryTableRows;
};
